var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOccam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_i_854_5354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3532 0.625977H7.86071H7.8566H7.85629H7.35956C5.7555 0.625977 4.85412 1.95031 4.427 3.61047L0.968932 15.2661C0.919576 15.4328 0.897429 15.6077 0.913248 15.7812C1.05436 17.3046 2.32116 18.4821 3.83284 18.4821H6.64295H6.64327H24.5471C26.0885 18.4821 27.3382 17.2949 27.4686 15.7626C27.4822 15.6022 27.4645 15.4402 27.4227 15.2847L24.2858 3.61047C23.8197 2.06332 22.9823 0.625977 21.3532 0.625977ZM4.12011 16.7659C4.06158 16.8251 3.97964 16.5698 3.91794 16.3305C3.85783 16.0968 3.86163 15.8508 3.92585 15.6183L7.35956 3.15132C7.62691 2.063 7.99043 1.46121 8.83644 1.26351H19.5014L4.12011 16.7659ZM24.5471 15.9567C24.5471 17.0273 23.6941 17.8954 22.6422 17.8954H7.9126C7.66487 17.8954 7.54275 17.5892 7.71992 17.4134L17.847 7.36032C18.9999 6.21244 19.5014 4.40127 19.5014 2.9475C19.5014 2.05141 19.7998 1.52496 20.1604 1.35399C20.8596 1.64088 21.158 2.28904 21.3532 3.15132L24.5471 15.9567Z",
    fill: "url(#paint0_linear_854_5354)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_854_5354",
    x: 0.908203,
    y: 0.625977,
    width: 26.5645,
    height: 21.1444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.28842
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.372549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_854_5354"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_854_5354",
    x1: 14.1906,
    y1: 0.625977,
    x2: 14.1906,
    y2: 18.4821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#31334A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151821"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccam);
export default __webpack_public_path__ + "static/media/occam.af9896b57da96856f4cfe734a03491b1.svg";
export { ForwardRef as ReactComponent };